module.exports = __webpack_public_path__ + "img/login-google-es.bc8ce1c9.png";